// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"828":"0770b531","842":"a16c6724"}[chunkId] + ".chunk.js";
};